/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React from 'react'
import { Header, Segment, Form, Grid, Placeholder } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import { UltyInputText } from '@ulty/ulty-ui'
import { FeatureInfo } from '../../Shared/FeatureInfo/FeatureInfo'


const MarginHeader = ({platforms, isLoadingPlatforms, onCommissionRateUpdate}) => {
    const [t] = useTranslation()

    const handleCommissionChange = (platformId, value) => {
        let valueNumber = value !== '' ? parseFloat(value) : null
        valueNumber = isNaN(valueNumber) ? null : valueNumber

        onCommissionRateUpdate?.({platformId, commissionRate: valueNumber})
    }

    return (
      <>
          <div>
              <Header
                as='h2'
                css={css`
                    display: inline;

                    &.ui.header {
                        margin-right: .5rem;
                        margin-top: .5rem;
                    }
                `}
              >
                  {t('margin.title')}
              </Header>

              <FeatureInfo featureName="margin">
                  <FeatureInfo.Text>{t('margin.feature_info.subheader')}</FeatureInfo.Text>
                  <FeatureInfo.List>
                      <FeatureInfo.ListItem>{t('margin.feature_info.item1')}</FeatureInfo.ListItem>
                      <FeatureInfo.ListItem>{t('margin.feature_info.item2')}</FeatureInfo.ListItem>
                      <FeatureInfo.ListItem>{t('margin.feature_info.item3')}</FeatureInfo.ListItem>
                  </FeatureInfo.List>
                  <FeatureInfo.Text>{t('margin.feature_info.footer')}</FeatureInfo.Text>
              </FeatureInfo>
          </div>
          <Segment attached="top" compact>

              {/* Platform Commission Rates */}
              <Form css={css`
              `}>
                  <Header as="h3">{t('margin.platformCommissions', 'Taux de commission par plateforme')}</Header>
                  {isLoadingPlatforms ? (
                    <Placeholder css={css`max-width: 100% !important`}>
                        <Placeholder.Line length="full"></Placeholder.Line>
                        <Placeholder.Line length="full"></Placeholder.Line>
                        <Placeholder.Line length="full"></Placeholder.Line>
                    </Placeholder>) : (
                    <Grid columns={3}>
                        {platforms && platforms.length > 0 ? (
                          platforms.map(platform => (
                            <Grid.Column key={platform.id}>
                                <UltyInputText
                                  label={t('margin.commissionRate', 'Commission {{platform}}', {platform: platform.name})}
                                  value={platform.commissionRate || ''}
                                  type="number"
                                  min={0}
                                  max={99}
                                  action="%"
                                  onChange={(e) => handleCommissionChange(platform.id, e.target.value)}
                                  placeholder={t('margin.enterCommission', 'Saisissez le taux (%)')}
                                />
                            </Grid.Column>
                          ))
                        ) : (
                          <Grid.Column>
                              <p>{t('margin.noPlatforms', 'No platforms available')}</p>
                          </Grid.Column>
                        )}
                    </Grid>
                  )
                  }

              </Form>
          </Segment>
      </>
    )
}

export default MarginHeader
